// src/Components/Assets/AssetCard.js

import React, { useState } from 'react';
import { Dropdown, Modal, Input } from 'antd';
import { EllipsisOutlined, PlayCircleOutlined, DownloadOutlined, EditOutlined, DeleteOutlined } from '@ant-design/icons';

const AssetCard = ({ asset, onDelete, onRename, onPreview }) => {
  const isVideo = asset.name?.match(/\.(mp4|mov|webm)$/i);
  // --- THIS IS THE FIX: Added a check for document types ---
  const isDocument = asset.name?.match(/\.(pdf|docx|pptx)$/i);
  // --- END OF FIX ---
  const [isRenameModalVisible, setIsRenameModalVisible] = useState(false);
  const [newAssetName, setNewAssetName] = useState('');

  const handleRename = () => {
    onRename(asset.url, newAssetName);
    setIsRenameModalVisible(false);
  };
  
  const showRenameModal = () => {
    const nameWithoutExtension = asset.name.split('.').slice(0, -1).join('.');
    setNewAssetName(nameWithoutExtension);
    setIsRenameModalVisible(true);
  };

  const menuItems = [
    {
      key: 'download',
      icon: <DownloadOutlined />,
      label: <a href={asset.url} target="_blank" rel="noopener noreferrer" download={asset.name}>Download</a>,
    },
    { key: 'rename', icon: <EditOutlined />, label: 'Rename', onClick: showRenameModal },
    {
      key: 'delete',
      icon: <DeleteOutlined />,
      label: 'Delete',
      danger: true,
      onClick: () => {
        Modal.confirm({
          title: 'Delete Asset',
          content: 'Are you sure you want to delete this asset?',
          okText: 'Delete',
          okType: 'danger',
          onOk: () => onDelete(asset.url),
        });
      },
    },
  ];

  return (
    <>
      {/* Main clickable card area for preview */}
      <div 
        className="relative group aspect-square bg-gray-100 rounded-lg overflow-hidden shadow-sm border cursor-pointer"
        onClick={() => onPreview(asset)}
      >
        {/* --- THIS IS THE FIX: Added dedicated UI for documents --- */}
        {isDocument ? (
            <div className="w-full h-full bg-gray-200 flex flex-col items-center justify-center text-center p-2">
                <i className="fa-solid fa-file-alt text-4xl text-gray-500"></i>
                <p className="text-xs text-gray-600 mt-2 font-semibold break-all">{asset.name}</p>
            </div>
        ) : isVideo ? (
        // --- END OF FIX ---
          <>
            <video src={asset.url} className="w-full h-full object-cover" />
            <div className="absolute inset-0 flex items-center justify-center bg-black bg-opacity-20 pointer-events-none">
              <PlayCircleOutlined className="text-white text-4xl opacity-80" />
            </div>
          </>
        ) : (
          <img src={asset.url} alt={asset.name} className="w-full h-full object-cover" />
        )}
        
        <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none" />

        <div className="absolute inset-0 p-2 flex flex-col justify-between">
            <div className="flex justify-end opacity-0 group-hover:opacity-100 transition-opacity duration-300 z-20">
                <Dropdown menu={{ items: menuItems }} trigger={['click']} placement="bottomRight">
                  <button 
                      className="w-8 h-8 flex items-center justify-center bg-white/80 rounded-full hover:bg-white backdrop-blur-sm shadow"
                      onClick={(e) => e.stopPropagation()} // Stop propagation to prevent modal open
                  >
                      <EllipsisOutlined className="text-lg text-gray-700" />
                  </button>
                </Dropdown>
            </div>
            {!isDocument && (
                <p className="text-white text-xs font-medium truncate self-start opacity-0 group-hover:opacity-100 transition-opacity duration-300 z-10">
                    {asset.name}
                </p>
            )}
        </div>
      </div>
      
      <Modal
        title="Rename Asset"
        open={isRenameModalVisible}
        onOk={handleRename}
        onCancel={() => setIsRenameModalVisible(false)}
        okText="Rename"
        destroyOnClose
      >
        <p className="text-sm text-gray-500 mb-2">Enter the new name for the file (extension will be kept).</p>
        <Input 
          value={newAssetName}
          onChange={(e) => setNewAssetName(e.target.value)}
          placeholder="Enter new asset name"
          onPressEnter={handleRename}
        />
      </Modal>
    </>
  );
};

export default AssetCard;